import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useCallback } from "react";
import { Button } from "../../../../../../base/buttons/button/index.js";
import { ProductCardTab } from "../types.js";
import * as S from "./styled.js";
const Tabs = ({ isTabSummary , summary , moreInfo , isVisible , goToTab  })=>{
    const goToTabSummary = useCallback((event)=>{
        event.preventDefault();
        goToTab(ProductCardTab.SUMMARY);
    }, [
        goToTab
    ]);
    const goToTabMoreInfo = useCallback((event)=>{
        event.preventDefault();
        goToTab(ProductCardTab.MORE_INFO);
    }, [
        goToTab
    ]);
    if (!isVisible) return null;
    return /*#__PURE__*/ _jsxs(S.ProductCardTab, {
        "data-testid": "Tabs",
        children: [
            /*#__PURE__*/ _jsx("li", {
                children: /*#__PURE__*/ _jsx(Button, {
                    className: classNames({
                        'is-active': isTabSummary
                    }),
                    onClick: goToTabSummary,
                    size: "small",
                    children: summary
                })
            }),
            /*#__PURE__*/ _jsx("li", {
                children: /*#__PURE__*/ _jsx(Button, {
                    className: classNames({
                        'is-active': !isTabSummary
                    }),
                    onClick: goToTabMoreInfo,
                    size: "small",
                    children: moreInfo
                })
            })
        ]
    });
};
export default Tabs;

//# sourceMappingURL=index.js.map